import '../scss/front.scss'

// Bootstrap: import only the Offcanvas component (the only Bootstrap JS the
// theme actually uses). Saves ~22 KiB vs the full bootstrap.bundle.min.js.
// The module side-effect registers the data-bs-toggle="offcanvas" data-API.
// We pull the ESM source under js/src/, not js/dist/, because the dist UMD
// build trips webpack 5's tree-shaking on its circular util/scrollbar import
// chain (TypeError "n.n is not a function" at runtime).
import 'bootstrap/js/src/offcanvas'

import { initApostasBurger } from './components/apostas-burger'
import { initApostasMenu } from './components/apostas-menu'
import { BurgerButtonToggle, OffcanvasClickAway, ScrollMobileMenu } from './components/menu'
import { OffCanvas } from './components/offCanvas'
import { errorSearchToggle, headerSearchToggle, OffcanvasSearchClickAway, searchPosts } from './components/search'

window.addEventListener('DOMContentLoaded', () => {
  OffcanvasClickAway()
  ScrollMobileMenu()
  OffCanvas()
  BurgerButtonToggle()

  OffcanvasSearchClickAway()
  headerSearchToggle()
  errorSearchToggle()
  searchPosts()

  initApostasMenu()
  initApostasBurger()
})
